import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  Signal,
} from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  KEYCLOAK_EVENT_SIGNAL,
  KeycloakEventType,
  UserActivityService,
} from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import { CommonStateModule } from '@store-common/common.module';
import { AuthFacade } from '@store-common/facade/auth-facade';
import { TopBarFacade } from '@store-common/facade/top-bar.facade';
import { load } from '@store-common/select-translate-state/select-translate.action';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressBar, RouterOutlet, CommonStateModule],
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent {
  public loadingSignal: Signal<boolean> = this.topBarFacade.loadingSignal;

  private readonly authFacade: AuthFacade = inject(AuthFacade);
  private readonly store: Store = inject(Store);
  private readonly keycloakEvent = inject(KEYCLOAK_EVENT_SIGNAL);
  private readonly userActivityService: UserActivityService =
    inject(UserActivityService);

  constructor(
    private readonly keycloak: Keycloak,
    private readonly topBarFacade: TopBarFacade
  ) {
    effect(() => {
      const event = this.keycloakEvent();

      if (event.type === KeycloakEventType.AuthLogout) {
        this.authFacade.logout(true);
      }

      if (event.type === KeycloakEventType.TokenExpired) {
        if (this.userActivityService.isActive(300000)) {
          this.keycloak.updateToken(300000).then();
        } else {
          this.authFacade.logout(true);
        }
      }
    });
    registerLocaleData(localeRu, 'ru-RU');
    this.store.dispatch(load({ payload: 'ru-RU' }));
  }
}
